import { PlanSlug } from '@aibees/shared/definition';
import type { CatalogCellData } from '../types';
import { parseValueForSlug } from './parse-values-per-plan';

const FILTER_LABELS: Record<string, string> = {
  FILTERS_COMPANY_BASIC: 'Company Basic (Full Access)',
  FILTERS_COMPANY_ADVANCED: 'Company Advanced (Full Access)',
  FILTERS_PEOPLE_BASIC: 'People Basic (Full Access)',
  FILTERS_PEOPLE_ADVANCED: 'People Advanced (Full Access)',
};

function composeViewLimit(value: string | undefined): string {
  if (value === 'Unlimited') return 'Unlimited View Filter Results';
  if (value) return `View ${value} Filter Results`;
  return 'View Filter Results';
}

function composeSupport(value: string | undefined): string {
  if (value === 'Chat') return 'Chat Support';
  return value ?? 'Chat Support';
}

function composeSeats(value: string | undefined): string {
  const n = Number(value ?? 0);
  return `${n} ${n === 1 ? 'User' : 'Users'}`;
}

export function composeTitle(
  name: string,
  cell: CatalogCellData,
  slug: string
): string {
  const perPlan = parseValueForSlug(cell.values_per_plan, slug);

  switch (cell.code) {
    case 'SEATS':
      return composeSeats(perPlan);
    case 'VIEW_LIMIT':
    case 'VIEW_FILTER_RESULTS':
      return composeViewLimit(perPlan);
    case 'EXPORT_SELECTION_LIMIT':
      return `Select Up to ${perPlan ?? ''} Records`
        .replace(/\s+/g, ' ')
        .trim();
    case 'API_INTEGRATION':
    case 'API_RATE_LIMIT':
      // Cell carries per-hour rates; the inclusion list uses the design's
      // "+5 / 5 per Second" convention. Differentiate Scale via slug.
      return slug === PlanSlug.SCALE
        ? '+5 API Requests per Second (Scalable)'
        : '5 API Requests per Second';
    case 'SUPPORT':
      return composeSupport(perPlan);
    case 'SUPPORT_CHAT':
      return 'Chat Support';
    case 'SUPPORT_PRIVATE_SLACK':
      return 'Private Slack Channel';
    default:
      return FILTER_LABELS[cell.code] ?? name;
  }
}
